import { RouteType } from "types/RouteType";
import PORequisitionWorkflowStore from "./PORequisitionWorkflowStore";

const PORequisitionWorkflowRoute: RouteType = {
  name: "PO Requisition Workflow",
  path: "/workflows/po-requisition",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "PO Requisition & Approval",
      component: () => import("./PORequisitionWorkflowHeader"),
      enableRefreshButton: true,
      enableBackButton: false,
    },
    body: {
      component: () => import("./PORequisitionWorkflow"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    if (!rootStore.poRequisitionWorkflowStore) {
      rootStore.poRequisitionWorkflowStore = new PORequisitionWorkflowStore(
        rootStore
      );
    }
    const store = rootStore.poRequisitionWorkflowStore as PORequisitionWorkflowStore;
    await store.loadInitialData();
    return true;
  },
};

export default PORequisitionWorkflowRoute;